<template>
  <el-container class="index-con">
    <el-aside :class="showclass">
      <leftnav></leftnav>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header">
        <navcon></navcon>
      </el-header>
      <el-main clss="index-main" style="padding: 8px 10px 4px;">
        <div class="auto_out">
          <div class="auto_inner">
            <transition mode="out-in" name="slide-right">
              <keep-alive>
                <router-view v-if="$route.meta.keepalive"></router-view>
              </keep-alive>
            </transition>
            <transition mode="out-in" name="slide-right">
              <router-view v-if="!$route.meta.keepalive"></router-view>
            </transition>
          </div>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../components/navcon.vue'
import leftnav from '../components/leftnav.vue'
export default {
  name: 'index',
  data() {
    return {
      showclass: 'asideshow',
      showtype: false,
      soundUrl: "../assets/audio/di.mp3",
      sseUrl: 'https://test.buyunxt.com/release_part/sse/connect', // SSE 服务器地址
      eventSource: null, // EventSource 实例
      isConnected: false, // 连接状态
      statusText: '未连接', // 状态文本
      statusClass: 'text-gray-500', // 状态样式
      statusIcon: 'fa fa-circle-o', // 状态图标
      messages: [], // 消息列表
      shopid: 11,
      maxtimes: 10,
      currentTimes: 3000,
      time: 0,
      //这边 不会获取 getshopInfo
      noShopInfo: ["/authWelcome", "/addStore", '/alibabaAuth', '/about', '/toLog'],
    }
  },
  // 注册组件
  components: {
    navcon,
    leftnav
  },
  methods: {
    checkIsAlert(){
      this.$post(this.$api.check_is_alert).then(res => {
        if (res.status == 200) {
          if(res.data.is_alert == 1){
              this.$confirm('商城即将到期,为了不影响正常使用,请及时联系售后人员？(点击确定后,今日不再提醒)', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.$post(this.$api.sure_alert).then(res => {
                  if (res.status == 200) {
                    this.$message.success('确认提醒成功');
                  }
                }).finally(() => {
                  // this.loading = false;
                });
              });
            }
            
          }
        }
      )
    },
    connect() {
      if (this.isConnected) return;

      // 关闭已有连接
      if (this.eventSource) {
        this.eventSource.close();
      }
      let a = Math.random().toString(36).substring(2, 15);
      try {
        this.shopid = localStorage.getItem('shopId');
        this.eventSource = new EventSource(this.sseUrl + '/' + this.shopid + '/' + a + '?token=Bearer ' + localStorage.getItem('logintoken_shop'));
        if(this.time<this.maxtimes){
           this.eventSource.onopen = () => {
          this.isConnected = true;
          this.statusText = '已连接';
          this.statusClass = 'text-green-500';
          this.statusIcon = 'fa fa-check-circle';
          this.addMessage('SSE 连接已建立', '系统', 'bg-green-50');
        };
          this.time++;
        }
        // 连接成功回调
       

        // 接收默认事件消息
        this.eventSource.onmessage = (event) => {
          this.addMessage(event.data, '默认事件');
        };

        // 接收自定义事件（示例：notice 事件）
        this.eventSource.addEventListener('wd', (event) => {
          this.addMessage(event.data, '网店订单', 'bg-blue-50');
        });

        // 接收系统事件（示例：system 事件）
        this.eventSource.addEventListener('tc', (event) => {
          this.addMessage(event.data, '同城订单', 'bg-purple-50');
        });

        this.eventSource.addEventListener('gxc', (event) => {
          this.addMessage(event.data, '同城订单', 'bg-purple-50');
        });

        // 错误处理
        this.eventSource.onerror = (error) => {
          this.eventSource.close();
          this.statusText = '连接错误';
          this.statusClass = 'text-red-500';
          this.statusIcon = 'fa fa-exclamation-triangle';
          this.addMessage(`连接异常: ${error.message || '未知错误'}`, '错误', 'bg-red-50');
          
          // 连接关闭时自动重连（可选）
          if (this.eventSource && this.eventSource.readyState !== EventSource.OPEN) {
            // console.log(this.currentTimes,'ssss');
            this.addMessage('连接已关闭，尝试重连...', '系统', 'bg-orange-50');
            this.currentTimes = Math.min(this.currentTimes * 2, 60000); // 指数退避，最大60秒
           
            // 3秒后重连
            setTimeout(() => this.connect(), this.currentTimes);
          }
        };
      } catch (err) {
        this.addMessage(`初始化失败: ${err.message}`, '错误', 'bg-red-50');
      }
    },
    // 添加消息到列表
    addMessage(content, eventType = '默认事件', typeClass = 'bg-gray-100') {
      this.messages.push({
        content,
        eventType,
        typeClass
      });
      if (eventType == "网店订单") {
        const audio = new Audio();
        audio.src = require("../../static/audio/online.mp3")
        audio.volume = 0.5; // 控制音量（0-1）
        audio.play().catch(err => {
          // this.$message({
          //   message: '播报失败，有新的网店订单',
          //   type: 'error'
          // })
          console.log('播报失败，有新的网店订单:', err);
          // 浏览器可能会阻止自动播放，这里可以忽略或添加用户交互提示
        });
      }
      if (eventType == "同城订单") {
        const audio = new Audio();
        audio.src = require("../../static/audio/near.mp3")
        audio.volume = 0.5; // 控制音量（0-1）
        audio.play().catch(err => {
          // this.$message({
          //   message: '播报失败，有新的同城订单',
          //   type: 'error'
          // })
          console.log('播报失败，有新的网店订单:', err);
          // 浏览器可能会阻止自动播放，这里可以忽略或添加用户交互提示
        });
      }

      // console.log(this.messages);
    },
  },
  created() {
    this.connect()
    // 监听
    this.$root.Bus.$on('toggle', value => {
      if (value) {
        this.showclass = 'asideshow'
      } else {
        setTimeout(() => {
          this.showclass = 'aside'
        }, 300)
      }
    })
    // 检查是否需要提醒
    this.checkIsAlert();
    
  },
  beforeMount() {
    this.eventSource.close();
  },
  beforeUpdate() { },
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功
    // this.$message({
    //   message: '登录成功',
    //   type: 'success'
    // })
  }
}
</script>
<style scoped>
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background: #f8f8f8;
}

.aside {
  width: 64px !important;
  height: 100%;
  background-color: white;
  margin: 0px;
}

.asideshow {
  width: 200px !important;
  height: 100%;
  background-color: white;
  margin: 0px;
  box-shadow: 0px 0px 10px #e4e7ed;
  /* border-right: 1px solid #e4e7ed; */
}

.index-header,
.index-main {
  padding: 0px !important;
  overflow: hidden;
}

.slide-right-enter-active,
.slide-right-leave-active {
  will-change: transform;
  transition: all .2s;
}

.slide-right-enter {
  opacity: 0;
  transform: translateX(-100%);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translateX(0%);
}

.aside::-webkit-scrollbar,
.asideshow::-webkit-scrollbar {
  display: none;
}

.auto_out {
  min-height: 100%;
  display: flex;
}

.auto_inner {
  /* flex: 1; */
  width: 100%;
  /* height: calc(100vh - 94px); */
  background: white;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #EBEEF5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue